import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Browse.css';

const platforms = [
  {
    id: 'youtube',
    route: '/youtube',
    label: 'YouTube',
    emoji: '▶',
    description: 'Video creators & channels',
    gradient: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)',
    glow: 'rgba(255, 0, 0, 0.35)',
  },
  {
    id: 'instagram',
    route: '/instagram',
    label: 'Instagram',
    emoji: '◈',
    description: 'Photos & reels influencers',
    gradient: 'linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
    glow: 'rgba(220, 39, 67, 0.35)',
  },
  {
    id: 'blog',
    route: '/blog',
    label: 'Blog',
    emoji: '✍',
    description: 'Writers & content publishers',
    gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    glow: 'rgba(17, 153, 142, 0.35)',
  },
];

function Browse() {
  const navigate = useNavigate();

  return (
    <div className="browse-container">
      <div className="tabs-header">
        <h1>Browse Creators</h1>
        <p>Find the perfect fit for your brand across different platforms</p>
      </div>

      <div className="platform-selector">
        <p className="selector-label">Select a platform to get started</p>
        <div className="platform-cards">
          {platforms.map((p) => (
            <button
              key={p.id}
              className="platform-card"
              style={{
                '--card-gradient': p.gradient,
                '--card-glow': p.glow,
              }}
              onClick={() => navigate(p.route)}
            >
              <span className="platform-emoji">{p.emoji}</span>
              <span className="platform-name">{p.label}</span>
              <span className="platform-desc">{p.description}</span>
              <span className="platform-cta">Browse →</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Browse;
